var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShoppingOnline = function SvgShoppingOnline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.317,
    height: 16,
    viewBox: "0 0 18.317 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shopping-online",
    d: "M18,9.316a1.37,1.37,0,0,0-1.066-.474H11.974L10.535,3.918a.314.314,0,0,0-.6.176l1.388,4.747H7L8.385,4.095a.314.314,0,0,0-.6-.176L6.344,8.841h-5a1.333,1.333,0,0,0-1.056.476,1.334,1.334,0,0,0-.259,1.13L1.587,18.21A1.924,1.924,0,0,0,3.4,19.693H15.259a1.854,1.854,0,0,0,1.768-1.5l1.27-7.747A1.37,1.37,0,0,0,18,9.316Zm-.323,1.027-1.27,7.747a1.221,1.221,0,0,1-1.149.975H3.4A1.287,1.287,0,0,1,2.2,18.087L.646,10.324a.719.719,0,0,1,.13-.609.718.718,0,0,1,.571-.247H6.161L5.8,10.716a.314.314,0,0,0,.213.389.319.319,0,0,0,.088.013.314.314,0,0,0,.3-.226l.416-1.423H11.5l.416,1.423a.314.314,0,0,0,.3.226.306.306,0,0,0,.088-.013.314.314,0,0,0,.213-.389l-.365-1.247h4.778a.721.721,0,0,1,.742.874Zm-8.2,3.01V17.5a.314.314,0,0,1-.627,0V13.353a.314.314,0,0,1,.627,0Zm-3.172,0V17.5a.314.314,0,0,1-.627,0V13.353a.314.314,0,0,1,.627,0Zm6.344,0V17.5a.314.314,0,0,1-.627,0V13.353a.314.314,0,0,1,.627,0Z",
    transform: "translate(-0.001 -3.693)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingOnline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-online.58f5304e.svg";
export { ForwardRef as ReactComponent };